import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import styled from 'styled-components';

import Home from './components/Home';
import {Footer} from './components/home/Footer';

//HALO / protected / admin routes
import Login from './components/halo/Login';
import AdminRoute from './components/halo/AdminRoute';
import Dashboard from './components/halo/Dashboard';
import UserList from './components/halo/users/UserList';
import JargonList from './components/halo/jargons/JargonList';
import WordList from './components/halo/jargons/WordList';
import StyleList from './components/halo/styles/StyleList';

const OuterAppWrapper = styled.div`
  min-height:100vh;
  font-family: var(--jargon-font-face);
  color: var(--jargon-secondary);
  font-weight:400;
  background-color:#f0f0ed;
  border-top:12px solid var(--jargon-primary);
  margin: 0 auto;
  
    /* options */
	--grid-size: 30px;
	--grid-strength: 1px;
	--grid-dash: 5px;
  --grid-gap: 10px;
	--grid-color: #ddd;
	--paper-color: #f0f0ed;
  
   /* styling */
  background-color: var(--paper-color);
  background-size: var(--grid-gap) var(--grid-gap), var(--grid-size) var(--grid-size);
  background-image:
    linear-gradient(to bottom, transparent var(--grid-dash), var(--paper-color) var(--grid-dash)), 
    linear-gradient(to right, var(--grid-color) var(--grid-strength), transparent var(--grid-strength)),
    linear-gradient(to right, transparent var(--grid-dash), var(--paper-color) var(--grid-dash)),
    linear-gradient(to bottom, var(--grid-color) var(--grid-strength), transparent var(--grid-strength));

  `;
const AppWrapper = styled.div`
  max-width: var(--content-max-width);
  padding-left: var(--content-horizontal-padding);
  padding-right: var(--content-horizontal-padding);
  margin-left: auto;
  margin-right: auto;
`;

const App: React.FC = () => {
  return (
    <Router>
      <OuterAppWrapper>
      <AppWrapper>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/halo/login" element={<Login />} />

        {/* all these are protected admin routes, they should be wrapped in the ProtectedRoutes tag which will give them access to a User context*/}
          <Route path="/halo/dashboard" element={
            <AdminRoute><Dashboard /></AdminRoute>} />
          <Route path="/halo/users" element={<AdminRoute><UserList/></AdminRoute>} />
          <Route path="/halo/jargons" element={<AdminRoute><JargonList/></AdminRoute>} />
          <Route path="/halo/jargons/:jargonId/words" element={<AdminRoute><WordList /></AdminRoute>} />
          <Route path="/halo/styles" element={<AdminRoute><StyleList/></AdminRoute>} />
          

          
        </Routes>
      </AppWrapper>
      <Footer />
      </OuterAppWrapper>
    </Router>
  );
}

export default App;